import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';

export default makeSettingsReducer('reports');
